componentRegistryInstance.register('select', 'edit', 'hrd.components.form.SelectComponent');

hrd.components.form.SelectComponent = hrd.components.form.AbstractSelectLikeComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.SelectComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceEditFieldInner: function(field, id, klass) {
		let options = field.data('extra-options') || {};
		var provider = this.getProvider(field);
		if (provider) {
			hrd.utils.buildSelect(field, provider, {
				keyProperty: field.data('key-property'),
				labelProperty: this.getLabelProvider(field),
				keepLabelCase: field.data('keep-label-case') || false,
				initialValue: field.data('default') != undefined ? field.data('default') : null,
				noSort: !!(field.data('no-sort')),
				emptyList: !!(field.data('empty-list')),
				keepList: !!(field.data('keep-list')),
				keepProviderData: !!(field.data('keep-data')),
				extraArgs: this.getExtraArgs(field, options.forceToObject),
				optionExtraData: field.data('optionExtraData') ? field.data('optionExtraData').split(/[\s,]+/) : [],
				onChange: this.getOnChangeFn(field),
				ignoreIsSelectedAttribute: !!(field.data('ignoreIsSelectedAttribute'))
			});
		}
		let size = dashboardInstance.adaptSize(field.data('size') || '200');
		field.prop('multiple', 'multiple').css('height', size);

		var validations = field.data('validation');
		var isRequired = validations == undefined ? false : validations.indexOf('required') !== -1;

		var btnContainerId = `${id}-btn-container`;
		var $btnContainer = $(`#${btnContainerId}`);

		/* registering the created promise into this.ENHANCE_PHASE_PROMISES array */
		var selectProviderPromise = field.data('loaded');
		if (selectProviderPromise) {
			this.addEnhancePhasePromise(selectProviderPromise);
			selectProviderPromise.then(() => {
				const appearance = field.data('appearance') || 'checkbox';

				if(appearance === 'minimal') {
					const fnName = $.functionCase(`on-${field.data('name')}-toggle-all`);
					const template = this.settings.reference[field.data('template-row')];
					const created = this.settings.reference[`${field.data('template-row')}Created`];
					const onToggleAll = this.settings.reference[fnName];
					const $form = this.toolbox.get('formInstance.$form', this.settings);

					const $newField = field.toSelectMinimal({
						template: template ? template.bind(this.settings.reference) : (rowData) => rowData && rowData[field.data('label-property')] ? rowData[field.data('label-property')] : '',
						templateCreated: created ? created.bind(this.settings.reference) : () => {},
						onToggleAll: onToggleAll ? onToggleAll.bind(this.settings.reference) : () => {},
						formElement: $form.exists() ? $form.get(0) : null
					});

					if(field.usingChromaFlow()) {
						$.timeout(0)
							.then(() => {
								this.wrapForSelectAddon($newField);
								this.wrapForGenericSelectAddon($newField);
							});
					}
				} else {
					var refClassName = $.dashedCase(`${this.getFieldName()}SelectBox`);
					field
						.addClass('ui-inaccessible')
						.multiSelectToCheckboxes({
							appearance: appearance,
							className: `ui-widget-content ui-corner-all select-box-field editable-data ${refClassName}` + (isRequired ? ' required' : ''),
							css: {
								width: field.width(),
								height: size
							},
							optionClassName: 'ignore-for-fhs ignore-aw'
						});

					field.removeClass('ui-inaccessible');

					if (field.data('select-all') == true && $btnContainer.exists()) {
						var selectAll = $('.select-action.select-all', $btnContainer);
						selectAll.trigger('click');
					}
				}
			})
		}

		field
			.on('field-has-changed', (evt, data) => {
				field.multiSelectToCheckboxes('setValues', data.newValue);
			})
			.on('validation', (evt, isValid) => {
				if (!isValid) {
					$('.select-box-field', field.parent()).addClass('field-error');
				}
			});

		/* copy some needed data attributes to 'ref' element from main one */
		var refField = field.multiSelectToCheckboxes('ref');
		if (field.data('computeWidth') != undefined) {
			refField.attr('data-compute-width', field.data('computeWidth'));
		}

		if (field.data('buttons') && !$btnContainer.exists()) {
			/* aggiungo 3 bottoni */
			var btnContainer = $(`<span id="${btnContainerId}" class="select-btn-container"></span>`);

			var allBtn = $('<button type="button" class="select-action select-all dashlet-button inner-form-button"></button>')
				.button({
					label: xlate('common.form.select.all.btn')
				}).on('click', () => {
					$('input:checkbox', field.parent()).prop('checked', true);
					$($('option', field).get().reverse()).prop('selected', true);
				});

			var noneBtn = $('<button type="button" class="select-action select-none dashlet-button inner-form-button"></button>')
				.button({
					label: xlate('common.form.select.none.btn')
				}).on('click', () => {
					$('input:checkbox', field.parent()).prop('checked', false);
					$($('option', field).get().reverse()).prop('selected', false);
				});

			var invertBtn = $('<button type="button" class="select-action select-invert dashlet-button inner-form-button"></button>')
				.button({
					label: xlate('common.form.select.invert.btn')
				}).on('click', () => {
					$('input:checkbox', field.parent()).each((i, ck) => {
						$(ck).prop('checked', !$(ck).prop('checked'));
					});
					$($('option', field).get().reverse()).each((i, opt) => {
						$(opt).prop('selected', !$(opt).prop('selected'));
					});
				});
			btnContainer.append(allBtn).append(noneBtn).append(invertBtn);

			var btnRowLabel = $('<label></label>').text(xlate('common.form.select.actions.label'));
			var btnRow = $('<div class="field-composite"></div>');
			btnRow.append(btnRowLabel);
			btnRow.append(btnContainer);
			field.parent().before(btnRow);
		}
	},
	getEditableField: function(field, name, object, options) {
		var v;
		var appearance = field.data('appearance') || 'checkbox';
		if (appearance === 'radio') {
			v = field.val() == undefined ? undefined : field.val()[0];
			var $opt = $('option:selected', field);
			this.setValueByPath(object, name + 'Label', $opt.text());
			if ($opt.data() != undefined) {
				$.each($opt.data(), (k, v) => {
					if (k.indexOf('extra') == 0) {
						var p = k.substring(5);
						this.setValueByPath(object, name + p, v);
					}
				});
			}
		} else {
			v = field.val();
			if (v == null) {
				v = []; // forzo a [] per evitare di uploadare [null]
			}
		}
		this.setValueByPath(object, name, v);
	},
	setEditableField: function(field, value, object, options) {
		var loaded = field.data('loaded');
		if (loaded && loaded.then && loaded.state() === 'pending') {
			loaded.then(() => {
				field.val(value);
				field.removeData('loaded');
			});
		} else {
			field.val(value);
		}
	},
	initalizeComponent: function(field, initialValue) {
		let appearance = field.data('appearance') || 'checkbox';
		switch (appearance) {
			case 'checkbox':
				var initalValues = initialValue.split(',');
				field.selectOptions(initalValues);
				field.trigger('field-has-changed', { newValue: initalValues });
				break;
			case 'radio':
				field.selectOptions(initialValue);
				field.trigger('field-has-changed', { newValue: [initialValue] });
				break;
		}
	},
	resetEditableField: function(field, options) {
		field.val('');
		field.trigger('field-has-changed', { newValue: [] });
		var emptyList = !!field.data('empty-list');
		if (emptyList) {
			field.removeOption(/./); // removes all options before start adding the new ones
		}
		/* preselect again if declared so */
		if (field.data('select-all') == true) {
			let id = this.getFieldId();
			var $btnContainer = $(`#${id}-btn-container`);
			if ($btnContainer.exists()) {
				$('.select-action.select-all', $btnContainer).trigger('click');
			}
		}
	},

	wrapForSelectAddon: function(field) {
		if(!field.usingChromaFlow()) return;

		let $addon = field.closest('.field-composite').find('[data-variants~="select-addon"]');
		if(!$addon.exists()) {
			// const offset = field.next() && field.next().exists() ? field.next().outerWidth(true) : 0;
			const offset = 0;
			field
				.after(`
					<button style="--offset: ${offset}px" data-variants="${field.parent().is('.field-composite-2x') ? 'large' : ''} icon select-addon" data-action="${field.data('name')}Addon" data-show-text="false" data-icon-primary="fas fa-chevron-down" ${field.data('reset') === 'exclude' ? 'data-reset="exclude"' : ''}>
					</button>
				`);
			$('[data-variants~="select-addon"]', field.closest('.field-composite'))
				.button()
				.button('option', 'icons', { primary: `f-icon fas fa-chevron-down` });

			$addon = field.closest('.field-composite').find('[data-variants~="select-addon"]');
		}

		if($addon.exists() && !$addon.closest('.select-addon-container').exists()) {
			$addon
				.add($addon.siblings(this.wrappableSelectors))
				.wrapAll('<div class="select-addon-container field-container"></div>');
		}
	}
});